import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";
import { useFiles } from "../files/useFIles";

export const useCandidate = () => {
  const { getDownloadLinks } = useFiles();
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const getDataById = async (
    id: number | string
  ): Promise<any | null | undefined> => {
    try {
      const data = await ApiFetch.httpGet(
        URLS.get.tenant.candidateById.candidateId(id)
      );

      setData(data);
      setLoading(false);
      return data;
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      setLoading(false);
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getEnrichedDataById = async (
    id: number | string
  ): Promise<any | null | undefined> => {
    try {
      const data = await ApiFetch.httpGet(
        URLS.get.tenant.candidateById.candidateId(id)
      ).then(async (result: any) => {
        const [fileIds] = result?.candidateScreenings.map(
          (candidateScreening: any) =>
            candidateScreening?.candidateScreeningDocuments.map(
              (doc: any) => doc?.fileId
            )
        );

        //
        const downloadFiles = await getDownloadLinks(fileIds);

        result?.candidateScreenings.forEach((candidateScreening: any) =>
          candidateScreening?.candidateScreeningDocuments.forEach(
            (doc: any) => {
              const [enrichedDoc] = downloadFiles.filter(
                (file: any) => file?.fileId === doc?.fileId
              );
              doc.presignedUrl = enrichedDoc?.presignedUrl;
            }
          )
        );

        return result;
      });
      //
      setData(data);
      setLoading(false);
      return data;
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      setLoading(false);
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const removeCandidateScreening = async (id: number | string) => {
    try {
      await ApiFetch.httpGet(
        URLS.delete.tenant.candidateScreening.candidateScreeningId(id)
      );
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    }
  };

  const createCandidateScreening = async (id: number | string) => {
    try {
      await ApiFetch.httpGet(
        URLS.delete.tenant.candidateScreening.candidateScreeningId(id)
      );
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    }
  };
  const removeScreeningPerson = async (candidateScreeningId: number) => {
    try {
      await ApiFetch.httpDelete(
        `/v1/tenant/deleteCandidateScreening/${candidateScreeningId}`,
        {}
      );
      setData((prevSreeningData: any) => ({
        ...prevSreeningData,
        candidateScreenings: prevSreeningData.candidateScreenings.filter(
          (x: any) => x?.candidateScreening?.id !== candidateScreeningId
        ),
      }));
    } catch (error) {}
  };
  const addScreeningPerson = async (type: string, candidateId: number) => {
    try {
      const response = await ApiFetch.httpPost(
        "/v1/tenant/createCandidateScreening",
        {
          candidateId: candidateId,
          screeningType: type,
          employmentType: "EMPLOYEE",
        }
      );
      setData((prevScreeningData: any) => ({
        ...prevScreeningData,
        candidateScreenings: [
          ...prevScreeningData.candidateScreenings,
          {
            candidateScreening: { ...response, screeningType: type, employmentType: "EMPLOYEE" },
          },
        ],
      }));
    } catch (error) {}
  };

  const values: any = {
    data,
    setData,
    error,
    loading,
    getEnrichedDataById,
    addScreeningPerson,
    removeScreeningPerson,
    setLoading,
    setError,
    getDataById,
    removeCandidateScreening,
    createCandidateScreening,
  };

  return values;
};
